{{
  `components.processBar.processStatus.${processState}` | translate
}}
<div
  class="flex w-full gap-2 *:h-2 *:w-full *:transition-colors *:duration-1000"
>
  @for (state of PROCESS_STATUS; track state) {
    <div
      class="bg-grey-200"
      [ngClass]="{
        'animate-bgFade': $index === processIndex,
        'animate-bgFadeToSuccess bg-success': $index + 1 <= processIndex,
      }"
    ></div>
  }
</div>
